import anonymousImage from "../assets/images/boardOfDirectors/anonymousPerson.png";
import tawfikImage from "../assets/images/boardOfDirectors/Eng_Tawfik.png";
import walidImage from "../assets/images/boardOfDirectors/Mr_Walid.png";
import gamalImage from "../assets/images/ourTeam/Mr_Gamal.png";
import nohaImage from "../assets/images/ourTeam/NahlaMoussa.png";
import hanyImage from "../assets/images/ourTeam/Hany.png";
import minaImage from "../assets/images/ourTeam/Mina.png";
import nahlaResponsiveImage from "../assets/images/ourTeam/NahlaMoussaResponsive.png";
import hanyResponsiveImage from "../assets/images/ourTeam/HanyResponsive.png";
import minaResponsiveImage from "../assets/images/ourTeam/MinaResponsive.png";

const CFHManagment = [
  {
    image: tawfikImage,
    header: "Tawfik Diab ",
    paragraph: "Chairman & CEO",
  },
  {
    image: gamalImage,
    header: "Gamal Zaghloul",
    paragraph: "General Manager",
  },
  {
    image: anonymousImage,
    header: "Shady Sharaf",
    paragraph: "CIO- Chief Investment Officer",
    responsiveImage: anonymousImage,
  },
  {
    image: walidImage,
    header: "Ahmed Refaat",
    paragraph: "Financial Controller",
  },
  {
    image: anonymousImage,
    header: "Nahla Moussa",
    paragraph: "HR Manager",
    responsiveImage: anonymousImage,
  },

  {
    image: minaImage,
    header: "Mina Ibrahim",
    paragraph: "Digital Transformation",
    responsiveImage: minaResponsiveImage,
  },
];

export default CFHManagment;
